import { textAlign } from "@mui/system";
import { Paper } from "@mui/material";
import MaterialTable from "@material-table/core";
import { log } from "../../../../Helper";

const OrderTable = (props) => {
  const { tableData } = props;

  const columns = [
    {
      title: "OrderPathId",
      field: "orderPathId",
      hidden: true,
      sorting: true,
      headerStyle: {
        fontSize: "12px",
        fontWeight: "600",
        // textAlign: left !important,
      },
    },
    {
      title: "Comar",
      field: "comar",
      hidden: false,
      sorting: false,
      headerStyle: {
        fontSize: "12px",
        fontWeight: "600",
      },
    },
    {
      title: "Serial",
      field: "serialNumber",
      hidden: false,
      sorting: false,
      headerStyle: {
        fontSize: "12px",
        fontWeight: "600",
      },
    },
    {
      title: "Shipping Order",
      field: "shippingOrder",
      hidden: false,
      sorting: false,
      headerStyle: {
        fontSize: "12px",
        fontWeight: "600",
      },
    },
    {
      title: "Ship To",
      field: "shipToCountry",
      hidden: false,
      sorting: false,
      headerStyle: {
        fontSize: "12px",
        fontWeight: "600",
      },
    },
    {
      title: "Planned",
      field: "avisDate",
      hidden: false,
      sorting: false,
      headerStyle: {
        fontSize: "12px",
        fontWeight: "600",
      },
    },
    {
      title: "Supplier Number",
      field: "supplierNumber",
      hidden: true,
      sorting: true,
      headerStyle: {
        fontSize: "12px",
        fontWeight: "600",
      },
    },
  ];
  return (
    <MaterialTable
      columns={columns}
      localization={{
        body: {
          emptyDataSourceMessage: (
            <h6 className="left-[45%] absolute top-[40%] text-center">
              No records to display
            </h6>
          ),
        },
      }}
      options={{
        rowStyle: {
          fontSize: 14,
          background: "white",
        },
        selection: false,
        search: false,
        showTitle: false,
        grouping: false,
        pageSize: 100,
        filtering: false,
        paging: false,
        toolbar: false,
        maxBodyHeight: 172,
        draggable: false,
        headerStyle: {
          backgroundColor: "white",
          fontWeight: "400",
          color: "black",
          textAlign: "left",
          position: "sticky", // Make header sticky
          top: 0, // Stick to top
          zIndex: 10,
        },
        // pageSizeOptions: [100, 500, 1000],
        actionsColumnIndex: -1,
        filterCellStyle: {
          flex: 1,
        },
      }}
      title={"Quality Hold Orders"}
      data={tableData}
      // actions={[
      //   {
      //     tooltip: 'Remove All Selected Users',
      //     icon: 'delete',
      //     onClick: (evt, data) => alert('You want to delete ' + data.length + ' rows')
      //   }
      // ]}
      style={{ boxShadow: "none", textAlign: "left" }}
    />
  );
};

export default OrderTable;
